module.exports = __webpack_public_path__ + "img/modelo.f7358936.jpg";